var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 47,
    viewBox: "0 0 42 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.3258,
    cy: 19.7344,
    r: 12.6404,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0449 46.1523C32.0781 46.1523 41.2041 37.0264 41.2041 25.9932C41.2041 14.96 32.0576 5.85449 21.0244 5.85449C9.99123 5.85449 0.885763 14.96 0.885763 25.9932C0.885763 37.0264 10.0117 46.1523 21.0449 46.1523ZM18.8916 35.6113C18.1123 35.6113 17.4971 35.2832 16.9434 34.5654L12.2266 28.8643C11.8574 28.4131 11.6934 27.9414 11.6934 27.4287C11.6934 26.3828 12.5137 25.542 13.5596 25.542C14.1953 25.542 14.667 25.7881 15.1797 26.4033L18.8301 31.0176L26.7256 18.3848C27.1768 17.667 27.751 17.3184 28.3867 17.3184C29.4121 17.3184 30.335 18.0361 30.335 19.082C30.335 19.5537 30.1094 20.0459 29.8223 20.4971L20.7578 34.5449C20.3067 35.2422 19.6504 35.6113 18.8916 35.6113Z",
    fill: "#20AACA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/Check.e80255b5ee10c3436bf7904e04e6e180.svg";
export { ForwardRef as ReactComponent };